if (!customElements.get('gz-tab-content')) {
  class GzTabContent extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.contents = [];
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("[data-tab-btn]"));
      this.contents = Array.from(this.querySelectorAll("[data-tab-content]"));

      // Bind events
      this.buttons.forEach((btn, index) => {
        btn.addEventListener("click", () => this.openTab(btn.dataset.tabBtn));
        btn.addEventListener("keydown", (event) => this.onButtonKeyDown(event, index));
      });

      // Check if there's already an active button, if so open that tab
      const activeBtn = this.querySelector("[data-tab-btn].active");

      if (activeBtn) {
        this.openTab(activeBtn.dataset.tabBtn);
      } else if (this.buttons.length) {
        // Fallback to first tab if none are active
        this.openTab(this.buttons[0].dataset.tabBtn);
      }
    }

    // Standard WAI-ARIA tablist keyboard pattern: Left/Right (and Home/End)
    // move focus between tabs and activate the newly focused tab.
    onButtonKeyDown(event, index) {
      const keyToIndex = {
        ArrowRight: (index + 1) % this.buttons.length,
        ArrowLeft: (index - 1 + this.buttons.length) % this.buttons.length,
        Home: 0,
        End: this.buttons.length - 1,
      };

      const nextIndex = keyToIndex[event.key];
      if (nextIndex === undefined) return;

      event.preventDefault();
      const nextButton = this.buttons[nextIndex];
      this.openTab(nextButton.dataset.tabBtn);
      nextButton.focus();
    }

    openTab(id) {
      // Update buttons
      this.buttons.forEach(btn => {
        const isActive = btn.dataset.tabBtn === id;
        btn.classList.toggle("active", isActive);
        btn.setAttribute("aria-selected", isActive);
        btn.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      // Update tab content with inline style
      this.contents.forEach(content => {
        const match = content.dataset.tabContent === id;
        content.classList.toggle("active", match);
        content.style.display = match ? "" : "none";
      });
    }
  }
  customElements.define("gz-tab-content", GzTabContent);
}
